import Collapse from 'react-bootstrap/Collapse';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { KPAspectPlanet } from './KPAspectPlanet';
import { KPAspectCuspal } from './KPAspectCuspal';

export function KPAspectChart ({menuArray,userData}) {
  return(
    <>
      { userData===null || userData===undefined?<></>:
          <Collapse in={menuArray[7]} className="m-0 p-0 ">
              <Row id="aspectsChart" className="m-0 p-0">
                  <Col xs={12} lg={6} className="p-2 pt-0 m-0">
                    <KPAspectPlanet userData={userData}/>
                  </Col>
                  <Col xs={12} lg={6} className="p-2 pt-0 m-0">
                    <KPAspectCuspal userData={userData}/>
                  </Col>
              </Row>
          </Collapse>
      }
    </>  
  );
}
